<div class="flex flex-col modal-sidebar">
  <ng-content select="[header]"> </ng-content>
  <ng-content select="[menu]"></ng-content>
</div>
